import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { Helmet } from 'react-helmet-async';
// @mui
import {  Box, Grid } from '@mui/material';

// sections
import ForgetPassword from '../sections/auth/login/ForgetPassword';
import CustomSnackBar from '../components/snackbar';

// ----------------------------------------------------------------------

const ResetPassword = () => {

  // snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(null)

  return (
    <>
      <Helmet>
        <title>Reset Password | Teller One </title>
      </Helmet>
      <Grid container  sx={{ display: 'flex', flexDirection: 'column', alignItems:'center' ,justifyContent: 'center', }}>

          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems:'center' ,justifyContent: 'center', }}>
            <ForgetPassword setSnackbarOpen={setSnackbarOpen} setSnackbarMessage={setSnackbarMessage} />

          </Box>
      </Grid>
      <CustomSnackBar snackbarOpen={snackbarOpen} setSnackbarOpen={setSnackbarOpen} snackbarMessage={snackbarMessage && snackbarMessage.msg} success={snackbarMessage && snackbarMessage.success} />
    </>
  );
}
export default ResetPassword;